import { z as zod } from "zod"
import { isBlankValue } from "./helpers"

export const createPercentSchema = (options: { min?: number, max?: number } = {}) => {
  const min = options.min
  const max = options.max

  return zod
    .string()
    .refine(
      (value) => {
        if (isBlankValue(value)) return true
        return !isNaN(parseFloat(value))
      },
      { message: "Must be a number" },
    )
    .refine(
      (value) => {
        if (isBlankValue(value)) return true
        if (min === undefined) return true
        return parseFloat(value) >= min
      },
      { message: `Must be greater than or equal to ${min}` },
    )
    .refine(
      (value) => {
        if (isBlankValue(value)) return true
        if (max === undefined) return true
        return parseFloat(value) <= max
      },
      { message: `Must be less than or equal to ${max}` },
    )
}
